import { parametersStore, usePanelParametersSelector } from '../config';
import { parametersActions } from '../config/parametersStore';

const panelActionParameterName = '__panelTitleAction';
const panelImageParameterName = '__panelImageAction';
const panelDescriptionParameterName = '__panelTitleDescription';

export function setPanelTitleAction(panelId: string, newAction: string) {
  parametersStore.dispatch(
    parametersActions.udpate({
      panelId,
      parameters: { [panelActionParameterName]: newAction },
    }),
  );
}
export function setPanelTitleDescritpion(
  panelId: string,
  newDescription: string,
) {
  parametersStore.dispatch(
    parametersActions.udpate({
      panelId,
      parameters: { [panelDescriptionParameterName]: newDescription },
    }),
  );
}
export function setPanelImageAction(panelId: string, newImage: string) {
  parametersStore.dispatch(
    parametersActions.udpate({
      panelId,
      parameters: { [panelImageParameterName]: newImage },
    }),
  );
}

export function usePanelTitleAction() {
  return usePanelParametersSelector(
    (current) => current[panelActionParameterName] as string,
  );
}

export function usePanelImage() {
  return usePanelParametersSelector(
    (current) => current[panelImageParameterName] as string,
  );
}

export function usePanelTitleDescription() {
  return usePanelParametersSelector(
    (current) => current[panelDescriptionParameterName] as string,
  );
}
